module.exports = __webpack_public_path__ + "static/media/zona_giorno.ba97aa16.jpg";